module.exports = __webpack_public_path__ + "img/salsa_1360.52673130.jpg";